var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubOutScanShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 22V30C15.333 35.0283 15.333 37.5425 16.8951 39.1045C18.4572 40.6667 20.9714 40.6667 25.9997 40.6667H30.6663M40.6663 28V22",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1585 19.0863L15.333 22.0002H40.6663L38.9967 19.2175C37.8585 17.3204 37.2894 16.3719 36.3723 15.8527C35.4554 15.3335 34.3491 15.3335 32.1369 15.3335H23.938C21.773 15.3335 20.6905 15.3335 19.7865 15.8339C18.8825 16.3343 18.3078 17.2516 17.1585 19.0863Z",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22.0002V15.3335",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 26H30.6663",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.667 35.3335C40.667 35.3335 37.721 31.3335 36.667 31.3335C35.6129 31.3335 32.667 35.3335 32.667 35.3335M36.667 32.0002V40.6668",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubOutScanShipment);
export default __webpack_public_path__ + "static/media/HubOutScanShipment.2aaec46b89711d76ceaae120cca98f74.svg";
export { ForwardRef as ReactComponent };